<div class="zn-form" [formGroup]="form">
  <fieldset>
    <legend>
      {{ 'Geographic::StandDivision.StepDefineAttributeInheritance.Modal.MainAttributes' | abpLocalization }}
      <hr />
    </legend>

    <div class="row">
      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritanceStandType">
            {{ 'LanguageService::Stand.StandType' | abpLocalization }}
          </label>
          <zn-single-select
            id="attributeInheritanceStandType"
            [options]="standTypeOptions()"
            [optionsLoader]="loadStandTypeOptions"
            [showSearch]="true"
            [placeholder]="'Geographic::StandDivision.StepCreateAreaMaintenances.SelectPlaceholder' | abpLocalization"
            formControlName="StandTypeId"
            [localizationResource]="localizationResource"
            [openUp]="false"
          ></zn-single-select>
        </div>
      </div>

      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritanceRotation">
            {{ 'LanguageService::Stand.Rotation' | abpLocalization }}
          </label>
          <input
            id="attributeInheritanceRotation"
            class="form-control"
            type="number"
            formControlName="CurrentRotation"
            [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
          />
        </div>
      </div>

      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritanceNearbyPopulation">
            {{ 'LanguageService::Stand.NearbyPopulation' | abpLocalization }}
          </label>
          <zn-simple-select
            id="attributeInheritanceNearbyPopulation"
            [options]="nearbyPopulationOptions"
            [localizationResource]="localizationResource"
            [placeholder]="'SelectOption'"
            formControlName="HasNearbyPopulation"
          ></zn-simple-select>
        </div>
      </div>
    </div>
  </fieldset>

  <fieldset>
    <legend>
      {{ 'Geographic::StandDivision.StepDefineAttributeInheritance.Modal.PlantationAttributes' | abpLocalization }}
      <hr />
    </legend>

    <div class="row">
      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritancePlantingDate">
            {{ 'Geographic::Entity.Plantation.PlantationDate' | abpLocalization }}
          </label>
          <input
            id="attributeInheritancePlantingDate"
            class="form-control"
            [ngClass]="{
              'is-invalid': fieldInvalid('PlantingDate') && !plantingDatePicker.isOpen()
            }"
            ngbDatepicker
            #plantingDatePicker="ngbDatepicker"
            #plantingDateInput
            appDateMask
            formControlName="PlantingDate"
            [placeholder]="`${localizationResource}::DateFormat` | abpLocalization"
            (click)="plantingDatePicker.toggle()"
            (blur)="onPlantingDateBlur(plantingDateInput)"
          />
          @if (fieldInvalid('PlantingDate')) {
            @if (form.get('PlantingDate')?.hasError('invalidDate')) {
              <small class="invalid-feedback d-block">
                {{ `${localizationResource}::InvalidDateFormat` | abpLocalization }}
              </small>
            }
          }
        </div>
      </div>

      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritancePlantingType">
            {{ 'LanguageService::Stand.PlantingType' | abpLocalization }}
          </label>
          <zn-single-select
            id="attributeInheritancePlantingType"
            [options]="plantingTypeOptions()"
            [optionsLoader]="loadPlantingTypeOptions"
            [showSearch]="true"
            [placeholder]="'Geographic::StandDivision.StepCreateAreaMaintenances.SelectPlaceholder' | abpLocalization"
            formControlName="PlantingType"
            [localizationResource]="localizationResource"
            [openUp]="false"
          ></zn-single-select>
        </div>
      </div>

      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritanceGeneticMaterial">
            {{ 'LanguageService::Stand.GeneticMaterial' | abpLocalization }}
          </label>
          <zn-single-select
            id="attributeInheritanceGeneticMaterial"
            [options]="geneticMaterialOptions()"
            [optionsLoader]="loadGeneticMaterialOptions"
            [showSearch]="true"
            [placeholder]="'Geographic::StandDivision.StepCreateAreaMaintenances.SelectPlaceholder' | abpLocalization"
            formControlName="GeneticMaterial"
            [localizationResource]="localizationResource"
            [openUp]="false"
          ></zn-single-select>
        </div>
      </div>

      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritanceSpecies">
            {{ 'LanguageService::Stand.Species' | abpLocalization }}
          </label>
          <input
            id="attributeInheritanceSpecies"
            class="form-control"
            type="text"
            formControlName="Species"
            [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
            readonly
            [disabled]=true
          />
        </div>
      </div>
    </div>
  </fieldset>

  <fieldset>
    <legend>
      {{ 'Geographic::StandDivision.StepDefineAttributeInheritance.Modal.PlantingPlan' | abpLocalization }}
      <hr />
    </legend>

    <div class="row">
      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritanceSeason">
            {{ 'Geographic::StandDivision.StepDefineAttributeInheritance.Fields.Season' | abpLocalization }}
          </label>
          <zn-single-select
            id="attributeInheritanceSeason"
            [options]="seasonOptions()"
            [optionsLoader]="loadSeasonOptions"
            [showSearch]="true"
            [placeholder]="'SelectOption'"
            formControlName="Season"
            [openUp]="true"
          ></zn-single-select>
        </div>
      </div>

      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritanceContractor">
            {{ 'Geographic::StandDivision.StepDefineAttributeInheritance.Fields.Contractor' | abpLocalization }}
          </label>
          <zn-single-select
            id="attributeInheritanceContractor"
            [options]="contractorOptions()"
            [optionsLoader]="loadContractorOptions"
            [showSearch]="true"
            [placeholder]="'SelectOption'"
            formControlName="Contractor"
            [openUp]="true"
          ></zn-single-select>
        </div>
      </div>

      <div class="col-3">
        <div class="form-control-container">
          <label class="form-label" for="attributeInheritanceStandState">
            {{ 'Geographic::StandDivision.StepDefineAttributeInheritance.Fields.StandState' | abpLocalization }}
          </label>
          <zn-single-select
            id="attributeInheritanceStandState"
            [options]="standStateOptions()"
            [optionsLoader]="loadStandStateOptions"
            [showSearch]="true"
            [placeholder]="'SelectOption'"
            formControlName="StandState"
            [openUp]="true"
          ></zn-single-select>
        </div>
      </div>
    </div>
  </fieldset>
</div>
